import { ErrorBaseData } from '.'

export const medicalDocumentErrors: Record<string, ErrorBaseData> = {
  MedicalDocumentNotFoundException: {
    message: 'Documento médico não encontrado',
    description: 'Não foi possível encontrar o documento médico. Verifique as informações e tente novamente',
  },
  MedicalDocumentAlreadyExistsException: {
    message: 'Documento médico já gerado',
    description: 'Este documento médico já foi gerado para este atendimento',
  },
}
